import { render } from "./rightPanel.vue?vue&type=template&id=006f2522"
import script from "./rightPanel.vue?vue&type=script&lang=js"
export * from "./rightPanel.vue?vue&type=script&lang=js"

import "./rightPanel.vue?vue&type=style&index=0&id=006f2522&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__